import classNames from 'classnames';
import React from 'react';
import { Th as ResponsiveTh } from 'react-super-responsive-table';
import styles from './index.module.scss';
import type { CommonCellProps } from './utils';

export interface ThProps extends React.HTMLAttributes<HTMLTableHeaderCellElement>, CommonCellProps {
  actions?: boolean;
  colSpan?: number;
  field?: string;
  isActive?: boolean | null | undefined;
  /** Set a specific width on this? Include postfix when using strings, px assumed for numbers */
  width?: number | string;
}

export const Th: React.FC<ThProps> = props => {
  const {
    actions,
    centered,
    children,
    className,
    innerClass,
    isActive,
    numeric,
    rightAligned,
    width,
    ...rest
  } = props;
  const containerClass = classNames(
    styles.th,
    {
      [styles.active]: isActive,
      [styles.thActions]: actions,
      [styles.numeric]: numeric,
      [styles.centered]: centered,
      [styles.rightAligned]: rightAligned,
    },
    className
  );

  return (
    <ResponsiveTh {...rest} style={{ width, ...rest.style }} className={containerClass}>
      <div className={classNames(styles.inner, innerClass)}>{children}</div>
    </ResponsiveTh>
  );
};
